var _a, _b;
import { TipoDocumentoEnum } from './TipoDocumentoEnum';
export var TipoRequerenteReqEnum;
(function (TipoRequerenteReqEnum) {
    TipoRequerenteReqEnum["REQUERENTE"] = "REQUERENTE";
    TipoRequerenteReqEnum["PROCURADOR"] = "PROCURADOR";
    TipoRequerenteReqEnum["INVENTARIANTE"] = "INVENTARIANTE";
})(TipoRequerenteReqEnum || (TipoRequerenteReqEnum = {}));
export var TipoRequerenteOptions = {
    mapDescricao: (_a = {},
        _a[TipoRequerenteReqEnum.REQUERENTE] = 'Requerente',
        _a[TipoRequerenteReqEnum.PROCURADOR] = 'Procurador',
        _a[TipoRequerenteReqEnum.INVENTARIANTE] = 'Inventariante',
        _a),
    mapByValue: {
        1: TipoRequerenteReqEnum.REQUERENTE,
        2: TipoRequerenteReqEnum.PROCURADOR,
        3: TipoRequerenteReqEnum.INVENTARIANTE,
    },
    mapValue: (_b = {},
        _b[TipoRequerenteReqEnum.REQUERENTE] = 1,
        _b[TipoRequerenteReqEnum.PROCURADOR] = 2,
        _b[TipoRequerenteReqEnum.INVENTARIANTE] = 3,
        _b),
    getDescricao: function (key) {
        return this.mapDescricao[key];
    },
    getByValue: function (key) {
        return this.mapByValue[key];
    },
    getValue: function (key) {
        return this.mapValue[key];
    },
    getOptions: function () {
        return Object.entries(this.mapDescricao).map(function (_a) {
            var value = _a[0], label = _a[1];
            return ({
                label: label,
                value: value,
            });
        });
    },
    getRequerenteDesc: function (en, tipoDoc) {
        if (tipoDoc === TipoDocumentoEnum.PF) {
            switch (en) {
                case TipoRequerenteReqEnum.REQUERENTE:
                    return 'Requerente Pessoa Física';
                case TipoRequerenteReqEnum.PROCURADOR:
                    return 'Procurador de Pessoa Física';
                case TipoRequerenteReqEnum.INVENTARIANTE:
                    return 'Inventariante';
                default:
                    return 'Requerente Desconhecido';
            }
        }
        else {
            switch (en) {
                case TipoRequerenteReqEnum.REQUERENTE:
                    return 'Representante Legal';
                case TipoRequerenteReqEnum.PROCURADOR:
                    return 'Procurador de Pessoa Jurídica';
                default:
                    return 'Requerente Desconhecido';
            }
        }
    },
};
